import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { CustomerAuditLogService } from 'source/app/proxy';
import { CustomerAuditLogDto } from 'source/app/proxy/customers';

@Component({
  selector: 'app-main-group-auditlogs',
  standalone: true,
  imports: [CommonModule, NzTableModule, NzTagModule],
  templateUrl: './main-group-auditlogs.component.html',
  styleUrl: './main-group-auditlogs.component.scss'
})
export class MainGroupAuditlogsComponent implements OnInit {

  logs: CustomerAuditLogDto[] = [];
  loading = false;

  constructor(private service: CustomerAuditLogService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    // Rendered via ngComponentOutlet inside the generic master-register framework's
    // Audit Log tab, so this.route is the 'activity' route, not the 'read/:id' route -
    // walk up the parent chain to find the entity id (same pattern as CustomerGroupVisitComponent).
    let r: ActivatedRoute | null = this.route;
    while (r) {
      const id = r.snapshot.paramMap.get('id');
      if (id) {
        this.loadLogs(id);
        return;
      }
      r = r.parent;
    }
  }

  loadLogs(id: string): void {
    this.loading = true;

    const entityType = 'MainGroup';

    this.service.getLogs(id, entityType)
      .subscribe({
        next: (res) => {
          this.logs = res || [];
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        }
      });
  }

  getActionColor(action: string): string {
    if (!action) return 'default';

    if (action === 'Create' || action.endsWith('Added') || action === 'FileUploaded') {
      return 'green';
    }
    if (action === 'Delete' || action.endsWith('Deleted')) {
      return 'red';
    }
    if (action === 'Update' || action.endsWith('Updated')) {
      return 'blue';
    }
    return 'default';
  }
}
